import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../libs'
import {
  ClientAccount,
  ClientAccountArchive,
  ClientAccountEditSwapFree,
  ClientAccountLeverageEdit,
} from './types'
import { $params } from '../../../features/router'
import { Error } from '../edit/types'
import { updateClient } from '../edit/model'

export const clientAccountEditMounted = createEvent()
export const setClientAccountEdit = createEvent<ClientAccount>()
export const setError = createEvent<Error>()
export const $clientAccountEdit = restore(setClientAccountEdit, {
  accountId: '',
  clientId: '',
  serverId: 0,
  active: false,
  isDemo: false,
  balance: 0,
  currency: '',
  accountType: '',
  leverage: 0,
  leverageLimit: 0,
  isSwapFree: false,
  isFixRate: false,
  isChangeMTLeverage: false,
  availableForWithdrawal: false,
  tariff: '',
  accountPlatform: '',
  group: '',
  accountName: '',
  mtLogin: '',
  mtComment: '',
  login: 0,
  margin: 0,
  marginFree: 0,
  equity: 0,
  balanceDivider: 0,
  accCreatedAt: '',
  accUpdatedAt: '',
  status: '',
  archivedAt: null,
  archivingType: '',
})
export const $error = restore(setError, {
  message: '',
  code: 0,
})
export const submitEditClientAccountLeverage =
  createEvent<ClientAccountLeverageEdit>()
export const submitSwitchSwapfreeAccount =
  createEvent<ClientAccountEditSwapFree>()
export const submitArchiveAccount = createEvent<ClientAccountArchive>()
export const getClientAccount = fx<void, ClientAccount>({
  method: 'GET',
  url: '/account/',
})

export const updateClientAccountLeverage = fx<
  ClientAccountLeverageEdit,
  ClientAccount
>({
  method: 'PUT',
  url: '/account/',
})

export const updateClientAccountSwapfree = fx<
  ClientAccountEditSwapFree,
  ClientAccount
>({
  method: 'PUT',
  url: '/account/',
})

export const archiveAccount = fx<ClientAccountArchive, ClientAccount>({
  method: 'PUT',
  url: '/account/',
})

sample({
  clock: submitEditClientAccountLeverage,
  source: $params,
  fn: (params, clientAccount) => {
    return {
      url: `/account/${params?.accountID}`,
      body: {
        leverageLimit: Number(clientAccount.leverageLimit),
        isChangeMTLeverage: clientAccount.isChangeMTLeverage,
      },
    }
  },
  target: updateClientAccountLeverage,
})

sample({
  clock: submitSwitchSwapfreeAccount,
  source: $params,
  fn: (params, clientAccount) => {
    return {
      url: `/account/${params?.accountID}`,
      body: {
        isSwapFree: clientAccount.isSwapFree,
      },
    }
  },
  target: updateClientAccountSwapfree,
})

sample({
  clock: submitArchiveAccount,
  source: $params,
  fn: (params, clientAccount) => {
    return {
      url: `/account/${params?.accountID}`,
      body: {
        status: clientAccount.status,
      },
    }
  },
  target: archiveAccount,
})

sample({
  clock: clientAccountEditMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.accountID
    }
    return {
      url: `/account/${id}`,
    }
  },
  target: getClientAccount,
})

// update profile model

sample({
  clock: [
    getClientAccount.doneData,
    archiveAccount.doneData,
    updateClientAccountSwapfree.doneData,
    updateClientAccountLeverage.doneData,
  ],
  fn: (doneData) => doneData.body,
  target: setClientAccountEdit,
})
sample({
  clock: [
    getClientAccount.doneData,
    archiveAccount.doneData,
    updateClientAccountSwapfree.doneData,
    updateClientAccountLeverage.doneData,
  ],
  fn: (doneData) => {
    return { message: '', code: doneData.status }
  },
  target: [setError],
})

sample({
  clock: [
    getClientAccount.failData,
    archiveAccount.failData,
    updateClientAccountSwapfree.failData,
    updateClientAccountLeverage.failData,
  ],
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setError],
})
